import * as React from 'react';
import { format } from 'date-fns';
import { Controller, useForm } from 'react-hook-form';
import { toastr } from 'react-redux-toastr';
import ErrorMessage from '../../../components/text/ErrorMessage';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { WappNotificationTemplate } from '../../../core';
import CheckBox from '../../../components/check-box';

interface FormProps {
  messageTemplate: string;
  approvedReferenceTemplate?: string;
  isDocumentTemplate?: boolean;
  useBrochureTemplate?: boolean;
}

const WappTemplate: React.FunctionComponent<{
  templateDetails?: WappNotificationTemplate;
  isEdit: boolean;
  onSubmit: (data: any) => void;
  onClose?: () => void;
}> = (props) => {
  const { control, handleSubmit, errors, setValue, watch } = useForm<FormProps>(
    {
      reValidateMode: 'onChange',
      mode: 'onSubmit',
    }
  );

  React.useEffect(() => {
    if (!watch('messageTemplate') && props.templateDetails?.messageTemplate) {
      setValue('messageTemplate', props.templateDetails?.messageTemplate);
    }
    if (
      !watch('approvedReferenceTemplate') &&
      props.templateDetails?.messageTemplate
    ) {
      setValue(
        'approvedReferenceTemplate',
        props.templateDetails?.approvedReferenceTemplate
      );
    }
    if (
      !watch('isDocumentTemplate') &&
      props.templateDetails?.isDocumentTemplate
    ) {
      setValue('isDocumentTemplate', props.templateDetails?.isDocumentTemplate);
    }

    if (
      !watch('useBrochureTemplate') &&
      props.templateDetails?.useBrochureTemplate
    ) {
      setValue(
        'useBrochureTemplate',
        props.templateDetails?.useBrochureTemplate
      );
    }
  }, []);

  const onCopy = () => {
    toastr.success('Success', 'Copied to clip board');
  };

  return (
    <>
      <div className="col-xl-7 col-12 bg-gray-100">
        <div className="px-4 py-4 bg-gray-100">
          <div className="tab-content" id="activity-tabContent">
            <div
              className="tab-pane fade show active"
              id="note"
              role="tabpanel"
              aria-labelledby="note-tab"
            >
              <div className="row align-items-end mb-3">
                <div className="col-sm-9 col-12">
                  <h6 className="mb-1">{props.templateDetails?.subject}</h6>

                  {props.templateDetails?.updatedAt && (
                    <div className="font-xs text-gray-500">
                      Last Updated:{' '}
                      {format(
                        new Date(props.templateDetails?.updatedAt),
                        'dd/MM/yyyy hh:mm a'
                      )}
                    </div>
                  )}
                </div>
                <div className="col-sm-3 col-12 text-sm-right"></div>
              </div>

              <form onSubmit={handleSubmit(props.onSubmit)}>
                <div className="col-sm-12 col-12 py-4 bg-white">
                  <Controller
                    control={control}
                    name="approvedReferenceTemplate"
                    defaultValue={
                      props.templateDetails?.approvedReferenceTemplate
                    }
                    render={({ onChange, value, name }) => (
                      <>
                        <label> Approved Reference Template :</label>
                        <textarea
                          className="form-control rounded-sm font-weight-semibold"
                          placeholder="Approved Reference Template"
                          name={name}
                          value={value}
                          onChange={onChange}
                          id="subject"
                        />
                      </>
                    )}
                  />
                </div>
                <div className="col-sm-12 col-12 py-4 bg-white">
                  <Controller
                    control={control}
                    name="messageTemplate"
                    rules={{ required: 'Message Template is required' }}
                    defaultValue={props.templateDetails?.messageTemplate}
                    render={({ onChange, value, name }) => (
                      <>
                        <label> Editor Source :</label>

                        <textarea
                          className="form-control rounded-sm font-weight-semibold"
                          placeholder="Editor Source"
                          name={name}
                          value={value}
                          onChange={onChange}
                          id="subject"
                        />
                      </>
                    )}
                  />
                  {errors.messageTemplate && (
                    <ErrorMessage>Message Template is required</ErrorMessage>
                  )}
                </div>
                <div className="col-sm-12 col-12 py-4 bg-white">
                  <Controller
                    control={control}
                    name="isDocumentTemplate"
                    defaultValue={
                      props.templateDetails?.isDocumentTemplate || false
                    }
                    render={({ onChange, value, name }) => (
                      <CheckBox
                        id={`enabled-${
                          props.templateDetails?.isDocumentTemplate || ''
                        }`}
                        key="isDocumentTemplate"
                        label=" Is Document Template?"
                        name={name}
                        checked={value}
                        onChange={onChange}
                      />
                    )}
                  />
                </div>

                <div className="col-sm-12 col-12 py-4 bg-white">
                  <Controller
                    control={control}
                    name="useBrochureTemplate"
                    defaultValue={
                      props.templateDetails?.useBrochureTemplate || false
                    }
                    render={({ onChange, value, name }) => (
                      <CheckBox
                        id={`brochure-enabled-${
                          props.templateDetails?.useBrochureTemplate || ''
                        }`}
                        key="useBrochureTemplate"
                        label=" Use Brochure Template?"
                        name={name}
                        checked={value}
                        onChange={onChange}
                      />
                    )}
                  />
                </div>

                <div className="pt-4 pb-2 text-right">
                  <button
                    type="button"
                    onClick={props.onClose}
                    className="btn btn-outline-dark font-normal font-weight-semibold py-2 px-4 mr-1"
                  >
                    Cancel
                  </button>
                  <button className="btn btn-primary font-normal font-weight-semibold py-2">
                    Save
                  </button>
                </div>
                {/* </div> */}
              </form>
            </div>
          </div>
        </div>
      </div>
      <div className="col-xl-5 col-12 accordion p-4 bg-gray-100">
        {props.templateDetails?.placeholders && (
          <div className="bg-white col-12 px-0">
            <div className="d-flex align-items-center py-3">
              <div className="col">
                <h4 className="mb-2 font-weight-semibold">
                  Place Holder Values
                </h4>
                <p className="font-sm text-gray-500 mb-0">
                  To add value dynamically based on users, vehicles and others.
                  Use the following placeholders.
                </p>
              </div>
            </div>
            <div className="grid-table grid-table--sm border-top">
              <table>
                <tbody>
                  {props.templateDetails?.placeholders?.map((item: any) => {
                    return (
                      <tr className="cursor-pointer placeholder-row">
                        <td>{item.displayName}</td>
                        <td className="text-gray-500">
                          <span className="mr-1">:</span>
                          {item.value}
                        </td>
                        <td className="text-right">
                          <CopyToClipboard text={item.value} onCopy={onCopy}>
                            <button className="bg-gray-100 border btn font-weight-semibold font-xxs px-2 py-1 text-gray-600">
                              <i className="icon-copy d-xl-none"></i>
                              <span className="d-xl-block d-none">
                                Copy to clipboard
                              </span>
                            </button>
                          </CopyToClipboard>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default WappTemplate;
